import { FC } from 'react';
import { Marker } from 'react-map-gl';

import classes from './capture-position-marker.module.css';

interface CapturePositionMarkerProps {
  latitude: number;
  longitude: number;
  heading?: number | null;
}

export const CapturePositionMarker: FC<CapturePositionMarkerProps> = ({
  latitude,
  longitude,
  heading,
}) => (
  <Marker anchor="center" latitude={latitude} longitude={longitude}>
    <div className={classes.root}>
      {heading != null ? (
        <div
          className={classes.heading}
          style={{ transform: `rotate(${heading}deg)` }}
        />
      ) : null}
      <div className={classes.marker} />
    </div>
  </Marker>
);
